import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

/**
 * Validates that EITHER:
 * 1. The 'isAdmin' checkbox is checked (true)
 * OR
 * 2. The 'permissions' FormArray has items AND the 'entities' FormArray has items.
 */
export const adminOrPermissionsValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const formGroup = control as FormGroup;
  const isAdmin = formGroup.get('isAdmin')?.value;
  const permissions = formGroup.get('permissions')?.value;
  const entities = formGroup.get('entities')?.value;

  // Condition 1: If the user is an admin, the form is valid.
  if (isAdmin === true) {
    return null; // Valid
  }

  // Condition 2: Check if both permissions and entities have items.
  const hasPermissions = permissions && permissions.length > 0;
  const hasEntities = entities && entities.length > 0;

  if (hasPermissions && hasEntities) {
    return null; // Valid
  }

  // If neither condition is met, the form is invalid.
  // We return an error object that can be read by the parent FormGroup.
  return { adminOrPermissionsRequired: true };
};
